<template>
  <b-row class="pr-4">
    <b-col cols="12" class="d-flex align-items-center justify-content-between">
      <PageTitle title="Destaques no site" />
    </b-col>

    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">Destaques criados</h3>
      <b-button pill variant="success" @click="newHighlights()">
        <i class="fas fa-plus-circle mr-2"></i>
        Criar destaque
      </b-button>
    </b-col>

    <b-col cols="12">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>Icone</th>
            <th>Título</th>
            <th>Descrição</th>
            <th>Sub descrição</th>
            <th class="text-center">Ordem</th>
            <th class="text-center" style="width: 180px">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in highlights" :key="i">
            <td>{{item.icon}}</td>
            <td>{{item.name}}</td>
            <td>{{item.description}}</td>
            <td>{{item.text}}</td>
            <td class="text-center">{{item.order}}</td>
            <td class="text-center">
              <button class="btn btn-primary mr-2" v-b-tooltip.hover title="Editar" @click="editHighlights(item)">
                <i class="fas fa-edit"></i>
              </button>
              <button class="btn btn-danger" v-b-tooltip.hover title="Excluir" @click="deleteHighlights(item.id)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </b-col>

    <b-modal
      :title="fields.id == null ? 'Criar destaque' : 'Editar destaque'"
      size="md"
      id="modalHighlights"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-6 mt-2">
          <label class="mr-2">Icone *</label>
          <a href="https://pictogrammers.github.io/@mdi/font/2.0.46/" target="_black">Ver Icones</a>
          <input type="text" class="form-control" v-model="fields.icon">
        </div>

        <div class="col-6 mt-2">
          <label>Título *</label>
          <input type="text" class="form-control" v-model="fields.name">
        </div>

        <div class="col-12 mt-2">
          <label>Descrição</label>
          <input type="text" class="form-control" v-model="fields.description">
        </div>

        <div class="col-9 mt-2">
          <label>Sub descrição</label>
          <input type="text" class="form-control" v-model="fields.text">
        </div>

        <div class="col-3 mt-2">
          <label>Ordem</label>
          <input type="number" class="form-control" v-model="fields.order" @blur="fields.order < 0 ? fields.order = null : ''">
        </div>

        <div class="col-12 text-center mt-4">
          <button class="btn btn-success" @click="save()">
            Salvar
          </button>
        </div>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'ListDestaques',
  mixins: [makeToast],
  components: {
    PageTitle
  },
  data() {
    return {
      fields: {
        id: null,
        icon: '',
        name: '',
        description: '',
        text: '',
        order: null,
        construp_user_id: null
      },
      highlights: []
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  mounted() {
    this.list();
  },
  methods: {
    ...mapActions('shopkeeper', ['getHighlights', 'dellHighlights', 'saveHighlights']),
    list() {
      this.$store.dispatch('startLoader');
      this.getHighlights(this.userTypeId())
        .then((response) => {
          this.highlights = response.data;
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer os destaques', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    save() {
      if(this.fields.name == '' || this.fields.icon == '') {
        this.makeToast('Erro', 'Informe todos os campos obrigatórios!', 'danger');
        return;
      }

      this.fields.construp_user_id = this.userTypeId();

      this.$store.dispatch('startLoader');
      this.saveHighlights(this.fields)
        .then((response) => {
          if(response.data.error) {
            this.makeToast('Erro', 'Houve um erro ao salvar os dados', 'danger');
            return;
          }

          this.$bvModal.hide('modalHighlights');

          this.resetForm();
          this.list();

          this.makeToast('Sucesso', 'Destaque salvo com sucesso', 'success');
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao salvar os dados', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    deleteHighlights(id) {
      this.$store.dispatch('startLoader');
      this.dellHighlights(id)
        .then((response) => {
          if(response.data.error) {
            this.makeToast('Erro', 'Houve um erro ao excluir o destaque', 'danger');
            return;
          }
          this.list();

          this.makeToast('Sucesso', 'Destaque excluido com sucesso', 'success');
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao excluir o destaque', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    editHighlights(data) {
      this.fields = data;

      this.$bvModal.show('modalHighlights');
    },
    newHighlights() {
      this.resetForm();

      this.$bvModal.show('modalHighlights');
    },
    resetForm() {
      this.fields.id = null;
      this.fields.icon = '';
      this.fields.name = '';
      this.fields.description = '';
      this.fields.text = '';
      this.fields.order = null;
      this.fields.construp_user_id = null;
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
  },
};
</script>